<p-table [value]="data" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="req.pageSize"
    [first]="req.page" [showCurrentPageReport]="true" [rowHover]="true" dataKey="id" lazy="true" [totalRecords]="total"
    (onLazyLoad)="loadDataLazy($event)" [scrollable]="true" scrollHeight="flex"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

    <ng-template #caption>
        <div style="display: flex; justify-content: space-between;align-items: center;">
            <div class="flex flex-column align-items-center gap-2">
                <h3 class="m-0">Payments</h3>
                <p-button label="Export" icon="pi pi-download" severity="primary" (onClick)="exportData()" />
            </div>

            <div style="display: flex; gap: 0.5rem">

                <div class="flex flex-row gap-4 col-12 lg:col-6" style="align-items: end;">

                    <div class="flex flex-column gap-2" style="align-items: end;">
                        <p-iconfield iconPosition="left" class="ml-auto">
                            <p-inputicon>
                                <i class="pi pi-search"></i>
                            </p-inputicon>
                            <input pInputText type="text" [(ngModel)]="req.filter"
                                (ngModelChange)="onInputChange($event)" placeholder="Search keyword" />
                        </p-iconfield>

                        <p-multiselect [options]="paymentMethods" [(ngModel)]="req.paymentMethods" optionLabel="name"
                            optionValue="value" placeholder="Payment Methods" class="w-full md:w-56" appendTo="body"
                            (ngModelChange)="refresh()" [showClear]="true" />
                    </div>

                    <div class=" flex flex-column gap-2" style="align-items: flex-end;">
                        <p-inputnumber inputId="integeronly" [min]="0" [(ngModel)]="req.failedAttemptsFrom"
                            placeholder="Failed Attempts >" [showClear]="true" (ngModelChange)="refresh()" />
                        <p-inputnumber inputId="integeronly" [min]="0" [(ngModel)]="req.failedAttemptsTo"
                            placeholder="Failed Attempts <" [showClear]="true" (ngModelChange)="refresh()" />
                    </div>

                    <div class=" flex flex-column gap-2" style="align-items: flex-end;">
                        <div class="flex flex-row gap-2">
                            <label style="white-space: nowrap" for="includeNotScheduled">Include Not Scheduled</label>
                            <p-checkbox [(ngModel)]="req.includeNotScheduled" inputId="includeNotScheduled"
                                (ngModelChange)="refresh()" [binary]="true" />
                        </div>

                        <div class="flex flex-row gap-2">
                            <label style="white-space: nowrap" for="includeScheduled">Include Scheduled</label>
                            <p-checkbox [(ngModel)]="req.includeScheduled" inputId="includeScheduled"
                                (ngModelChange)="refresh()" [binary]="true" />
                        </div>
                        <div class=" flex flex-row gap-2">
                            <label style="white-space: nowrap" for="includePending">Include Pending</label>
                            <p-checkbox [(ngModel)]="req.includePending" inputId="includePending"
                                (ngModelChange)="refresh()" [binary]="true" />
                        </div>
                    </div>

                    <div class=" flex flex-column gap-2" style="align-items: flex-end;">
                        <div class=" flex flex-row gap-2">
                            <label style="white-space: nowrap" for="includeCompleted">Include Completed</label>
                            <p-checkbox [(ngModel)]="req.includeCompleted" inputId="includeCompleted"
                                (ngModelChange)="refresh()" [binary]="true" />
                        </div>
                        <div class="flex flex-row gap-2">
                            <label style="white-space: nowrap" for="includeFailed">Include Failed</label>
                            <p-checkbox [(ngModel)]="req.includeFailed" inputId="includeFailed"
                                (ngModelChange)="refresh()" [binary]="true" />
                        </div>
                        <div class=" flex flex-row gap-2">
                            <label style="white-space: nowrap" for="includeProcessing">Include Processing</label>
                            <p-checkbox [(ngModel)]="req.includeProcessing" inputId="includeProcessing"
                                (ngModelChange)="refresh()" [binary]="true" />
                        </div>
                    </div>

                    <div class=" flex flex-column gap-2" style="align-items: flex-end;">
                        <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="false"
                            [style]="{ width: '190px' }" (ngModelChange)="refresh()" appendTo="body"
                            dateFormat="dd/mm/yy" [showClear]="true" />

                        <p-multiselect [options]="dealTypes" [(ngModel)]="req.types" optionLabel="name"
                            optionValue="value" placeholder="Deal Types" class="w-full md:w-56" appendTo="body"
                            (ngModelChange)="refresh()" [showClear]="true" />
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th>Deal Id</th>
            <th>iHost Id</th>
            <th pSortableColumn="DatePaid">
                <div class="sort-col-container">
                    <span>Payment Date</span>
                    <p-sortIcon field="DatePaid" />
                </div>
            </th>
            <th pSortableColumn="DueDate">
                <div class="sort-col-container">
                    <span>Due Date</span>
                    <p-sortIcon field="DueDate" />
                </div>
            </th>
            <th>Method</th>
            <th pSortableColumn="FailedAttempts">
                <div class="sort-col-container">
                    <span>Failed Attempts</span>
                    <p-sortIcon field="FailedAttempts" />
                </div>
            </th>
            <th>Installment</th>
            <th>Amount</th>
            <th>Customer</th>
            <th>VAT</th>
            <th>Type</th>
            <th>Done</th>
            <th pSortableColumn="ErrorMessage">
                <div class="sort-col-container">
                    <span>Error</span>
                    <p-sortIcon field="ErrorMessage" />
                </div>
            </th>
            <th>Processing</th>
            <th>Processing Since</th>
        </tr>
    </ng-template>
    <ng-template #body let-payment>
        <tr>
            <td><a [href]="'/deals/edit/' + payment.dealCRMId">{{ payment.dealCRMId}}</a></td>
            <td>{{ payment?.deal?.customer?.ihostid }}</td>
            <td>{{ payment.datePaid | date: 'dd/MM/yyyy hh:mm' }}</td>
            <td>{{ payment.dueDate | date: 'dd/MM/yyyy' }}</td>
            <td>{{ payment.paymentMethod | paymentMethod }}</td>
            <td>{{ payment.failedAttempts }}</td>
            <td>{{ payment.index + "/" + payment.deal?.instalments }}</td>
            <td>{{ payment.amount | number: '2.2-2' }}</td>
            <td>{{ payment.deal?.customer.name }}</td>
            <td>{{ payment.deal?.customer.vatNumber }}</td>
            <td>{{ payment.deal?.type | dealType }}</td>
            <td>{{ payment.done | bool }}</td>
            <td>{{ payment.errorMessage }}</td>
            <td>{{ payment.isProcessing | bool }}</td>
            <td>{{ payment.processingSince | date: 'dd/MM/yyyy hh:mm' }}</td>
        </tr>
    </ng-template>
</p-table>